import {Event} from "../classes/Event";

/**
 *  Класс для страницы корзины
 * @extends Event
 */
export class Cart extends Event {
	constructor() {
		super();
		this.$clearButton = $("#js-order-clear");
		this.$orderRevert = $(".js-order-revert");
		this.$orderCancel = $(".js-order-cancel");
		this.$open = $(".js-bookings-open");
		this.parent = this.$open.parents(".bookings");
		this.$bookingDelete = this.parent.find(".js-booking-delete");
		this.$count = this.parent.find(".js-bookings-count");
		this.ordersCount = $(".js-order").length;
		this.$bookingsWrapper = this.parent.find(".js-bookings-wrapper");
		this.$serviceTicketRemove = $(".js-tickets-service-remove");
		this.$serviceRemove = $(".js-order-service-delete");
		super.initFrontend();
	}

	init() {
		this.toggleBookings();
		this.setCancelOrder();
		this.deleteFromCart();
		this.serviceTicketRemove();
		this.deleteService();
		$(".body").addClass("ready-for-test");
	}

	toggleBookings() {
		this.$open.on("click", e => {
			const element = $(e.currentTarget);
			element.toggleClass("active");
			this.$bookingsWrapper.slideToggle();
		});
	}

	deleteFromCart() {
		this.$bookingDelete.on("click", e => {
			const close = $(e.currentTarget);
			const booking = close.parents(".bookings__item");
			const order = $(booking).parents(".js-order");
			this.eventId = booking.data("eventId");
			this.subEventId = booking.data("subEventId");
			this.removeSubscriptionEventSids().then(response => {
				if (response.result) {
					booking.remove();
					this.$count.text(Number(this.$count.text()) - 1);
					if (Number(this.$count.text()) === 0) {
						if (this.ordersCount > 1) {
							order.remove();
						} else {
							window.location.reload();
						}
					}

					let sum = 0;
					$.each($(".js-booking"), (index, elem) => {
						const bookingItem = $(elem);
						const bookingSum = Number(bookingItem.find(".js-booking-sum").text());
						sum += bookingSum;
					});
					order.find(".js-sum").text(sum);
					this.getCartCount().then(res => {
						let discount = 0;
						$.each(res, (index, item) => {
							if (item.default_amount !== item.amount) {
								discount += item.default_amout - item.amount;
							}
							if (!discount) {
								order.find(".js-order-discount").hide();
							}
						});
					});
				}
			});
		});
	}

	setCancelOrder() {
		this.$orderRevert.on("click", e => {
			const element = $(e.currentTarget);
			this.eventId = element.data("event");
			const orderId = element.data("order");
			this.removeEventFromOrder(orderId).then(response => {
				if (response.success === 1) {
					location.reload();
				}
			});
		});

		this.$orderCancel.on("click", e => {
			const element = $(e.currentTarget);
			this.eventId = element.data("order");
			this.cancelOrder().then(response => {
				if (response.error === 0) {
					location.reload();
				}
			});
		});
	}

	serviceTicketRemove() {
		this.$serviceTicketRemove.on("click", e => {
			const $element = $(e.currentTarget);
			const $order = $element.parents(".js-order");
			const $eventSum = $order.find(".js-order-event-sum");
			const $promoDiscount = $order.find(".js-promo-discount");
			const uid = $element.data("uid");
			const serviceId = $element.data("service");
			this.deleteServiceTicket(serviceId, uid).then(res => {
				if (!res.carts.length) {
					window.location.reload();
				} else {
					$order.find(".js-sum").text(res.summ);
					$element.parents(".tickets__item").remove();
					let currentEventSum = 0;
					let discount = 0;
					$.each(res.carts, (index, elem) => {
						currentEventSum += elem.default_price;
						discount += elem.default_price - elem.price
					});

					$eventSum.text(currentEventSum);
					$promoDiscount.text(discount);
				}
			});
		});
	}

	deleteService() {
		this.$serviceRemove.on("click", e => {
			const $element = $(e.currentTarget);
			const $order = $element.parents(".js-order");
			const $tickets = $order.find(".tickets");

			$.each($tickets, (index, elem) => {
				const count = $(elem).data("count");
				const serviceId = $(elem).data("service");
				this.deleteServiceFromOrder(serviceId, count).then(res => {
					if (!res.carts.length) {
						window.location.reload();
					}
				});
			});
		});
	}
}

const cart = new Cart();
cart.init();
